import { render, staticRenderFns } from "./plan-design.vue?vue&type=template&id=44ee894c&scoped=true"
import script from "./plan-design.vue?vue&type=script&lang=js"
export * from "./plan-design.vue?vue&type=script&lang=js"
import style0 from "./plan-design.vue?vue&type=style&index=0&id=44ee894c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ee894c",
  null
  
)

export default component.exports